/** Coerce API / default values for v-text-field string models (avoids null.toString()). */
export function asFormString (value) {
  if (value === null || value === undefined) {
    return ''
  }
  return String(value)
}
